/**
 * The confetti burst from the older D2C payment-success page, fixed over the whole screen so the
 * current content stays readable underneath. Shown and hidden by `useConfettiBurst`.
 */
import Confetti from 'react-confetti';

export function CelebrationConfetti() {
  return (
    <Confetti
      recycle={false}
      numberOfPieces={300}
      className="fixed! inset-0"
      data-testid="celebration-confetti"
    />
  );
}
